import { render, staticRenderFns } from "./livelist.vue?vue&type=template&id=c13541cc&scoped=true&"
import script from "./livelist.vue?vue&type=script&lang=js&"
export * from "./livelist.vue?vue&type=script&lang=js&"
import style0 from "./livelist.vue?vue&type=style&index=0&id=c13541cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13541cc",
  null
  
)

export default component.exports